module.exports = __webpack_public_path__ + "static/media/Ownership&Benefits2x.3d05dbb7.png";